import React from 'react';
import Chart from 'react-apexcharts';
import _ from 'lodash';

const ColumnLineChart = ({
    options, chartSeries, type = 'line', height = 350 
}) => (

    <Chart height={height} options={_.cloneDeep(options)} series={chartSeries.length ? _.cloneDeep(chartSeries) : [{ name: '', data: [] }]} type={type} width='100%' />
);

export default ColumnLineChart;
